import GlobalSearch from './globalSearch'

export default GlobalSearch
